export default {
  TrayOpenURL: 'http://localhost:8090',
  CacheSize: 64,
  ReaderReadAHead: 95,
  PreloadCache: 50,
  PreloadCacheFixed: false,
  PreloadCacheSize: 50,
  CacheStartAfterEnd: true,
  UseDisk: false,
  TorrentsSavePath: '',
  RemoveCacheOnDrop: false,
  ForceEncrypt: false,
  RetrackersMode: 1,
  TorrentDisconnectTimeout: 30,
  EnableDebug: false,
  EnableDLNA: false,
  EnableBonjour: true,
  FriendlyName: '',
  EnableIPv6: false,
  DisableTCP: false,
  DisableUTP: false,
  DisableUPNP: false,
  DisableDHT: false,
  DisablePEX: false,
  DisableUpload: false,
  EnableLPD: true,
  LPDIPv6: false,
  DownloadRateLimit: 0,
  UploadRateLimit: 0,
  ConnectionsLimit: 25,
  PeersListenPort: 0,
  ResponsiveMode: true,
  SslPort: 0,
  SslCert: '',
  SslKey: '',
  ShowFSActiveTorr: true,
  StoreSettingsInJson: true,
}
